import React, { createContext, useContext } from 'react';

interface ExpandableAccordionContextValue {
  isAllExpanded: boolean;
  expandCommandSeq: number;
  onExpandChange: (isExpanded: boolean) => void;
}

export const ExpandableAccordionContext =
  createContext<ExpandableAccordionContextValue>({
    isAllExpanded: false,
    expandCommandSeq: 0,
    onExpandChange: () => {},
  });

export const useExpandableAccordionContext = () =>
  useContext(ExpandableAccordionContext);

interface ExpandableAccordionProps {
  isAllExpanded?: boolean;
  expandCommandSeq?: number;
  onExpandChange?: (isExpanded: boolean) => void;
  children: React.ReactNode;
}

export const ExpandableAccordion = ({
  isAllExpanded = false,
  expandCommandSeq = 0,
  onExpandChange = () => {},
  children,
}: ExpandableAccordionProps) => (
  <ExpandableAccordionContext.Provider
    value={{ isAllExpanded, expandCommandSeq, onExpandChange }}
  >
    {children}
  </ExpandableAccordionContext.Provider>
);
